import React from "react";
import { PeekAlert, PeekSnackbar, PeekTypography, PeekScreenLoader, PeekBox } from "@piiqtechnologies/ui-components";
import { Outlet } from "react-router-dom";
import { useError, useLoader, useNotification } from "@piiqtechnologies/ui-lib";
export const AppLayout = ({}) => {
    const { error, setError } = useError();
    const { notification, setNotification } = useNotification();
    const { loader, queue } = useLoader();
    const handleCloseAlert = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }
        setError(null);
        setNotification(null);
    };
    return (React.createElement(PeekBox, { sx: { backgroundColor: "grey.50", overflowY: "auto" }, height: "100vh" },
        loader && React.createElement(PeekScreenLoader, { layered: true }),
        React.createElement(Outlet, null),
        React.createElement(PeekSnackbar, { anchorOrigin: { vertical: "top", horizontal: "right" }, open: !!error || !!notification, autoHideDuration: 3000, "data-testid": "app-error", onClose: handleCloseAlert },
            React.createElement(PeekBox, null,
                React.createElement(PeekAlert, { sx: { alignItems: "center" }, onClose: handleCloseAlert, severity: (error && "error") || "success" },
                    React.createElement(PeekTypography, { variant: "body1" }, error || notification))))));
};
export default AppLayout;
